import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import app from "../../core/application";
import * as Constants from "../../core/constants";
import { sendRequest } from "../../helpers/ajax";
import IClientChangeIsActiveRequest from "../../types/IClientChangeIsActiveRequest";
import IClientEditMaster from "../../types/IClientEditMaster";
import IResponse from "../../types/IResponse";
import ClientEdit from "./ClientEdit";

interface IClientEditContainerState {
    clientID: number;
    loading: boolean;
    client: IClientEditMaster;
}

class ClientEditContainer extends React.Component<RouteComponentProps<any>, IClientEditContainerState> {

    constructor(props: RouteComponentProps<any>) {
        super(props);

        this.state = {
            clientID: this.props.match.params.clientID ? this.props.match.params.clientID : 0,
            loading: false,
            client: { 
                clientName: "",
                resourceTag: "",
                id: 0,
                isActive: true,
                adminLicenseKey: "",
                licenseKeys: [],
                description: ""
             }
        };

        this.loadClient = this.loadClient.bind(this);
        this.saveClient = this.saveClient.bind(this);
        this.toggleClientStatus = this.toggleClientStatus.bind(this);
    }

    public async componentDidMount() {
        this.loadClient();
    }

    public render() {
        return (
            <ClientEdit loading={this.state.loading}
                client={this.state.client}
                saveClient={this.saveClient}
                toggleClientStatus={this.toggleClientStatus}
                canLoginAsClient = {app().userHasPermission(Constants.PERMISSION_ADMINACCESSTOALLCLIENTS)} />
        );
    }

    private async saveClient(client: IClientEditMaster): Promise<IResponse<IClientEditMaster> | null> {

        this.setState({ loading: true });
        const response = await sendRequest<IResponse<IClientEditMaster>>("/api/client/save", "POST", client);
        this.setState({ loading: false });

        if (response && response.success && response.payload) {
            this.setState({ clientID: response.payload.id, client: response.payload });
        }

        return response;
    }

    private async loadClient() {
        this.setState({ loading: true });
        const response = await sendRequest<IResponse<IClientEditMaster>>(`/api/client/getById/${this.state.clientID}`, "GET");
        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ client: response.payload });
        }
    }

    private async toggleClientStatus(status: boolean) {
        this.setState({ loading: true });

        const request: IClientChangeIsActiveRequest = { 
            clientHeaderID: this.state.clientID, 
            isActive: status,
        };
        const response = await sendRequest<IResponse<IClientEditMaster>>("/api/client/ChangeClientIsActive", "POST", request);

        this.setState({ loading: false });

        if (response && response.success) {
            this.setState({ client: response.payload });
        }
    }
}

export default withRouter(ClientEditContainer);



// WEBPACK FOOTER //
// ./src/components/ClientEdit/ClientEditContainer.tsx